// extracted by mini-css-extract-plugin
module.exports = {"SocialMedia-Links":"SocialMediaLinks_SocialMedia-Links__3kY1-"};